import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "myoyakuCondition",
})
export class MyoyakuConditionPipe implements PipeTransform {
  transform(list: any[], Id, Kbn): string {
    var fStr = Kbn + "_" + Id;
    var fList = list.filter((item) => item.id == fStr);
    var result = "設定なし";
    if (fList.length > 0) {
      result = fList[0].conditions_name;
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/myoyaku-condition.pipe.ts